import clsx from "clsx";
import React, { useState } from "react";
import Sidebar from "../sidebar/Sidebar";
import Header from "../header/Header";

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="text-primary-fg flex h-screen">
      <div
        className={clsx(
          "fixed inset-y-0 z-50 flex w-[260px] flex-col transition-transform duration-300 lg:translate-x-0",
          "bg-card",
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        )}
      >
        <div className="flex grow flex-col gap-y-2 overflow-y-auto border-r border-border px-4 pb-4">
          <div className="flex h-18 shrink-0 items-center justify-between mb-4">
            <div className="text-2xl md:text-3xl font-bold text-primary">
              FormlyAdmin
            </div>
            <button
              type="button"
              className="-m-2.5 p-2.5 lg:hidden"
              onClick={() => setSidebarOpen(false)}
            >
              <span className="sr-only">Close sidebar</span>
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <nav className="flex flex-1 flex-col">
            <Sidebar />
          </nav>
        </div>
      </div>

      {/*  Main content */}
      <div className="lg:pl-[260px] w-full flex flex-col h-screen">
        {/* <!-- Header --> */}
        <div className="bg-card sticky top-0 z-40 flex h-20 shrink-0 items-center gap-x-4 border-b border-border px-4 shadow-xs sm:gap-x-6 sm:px-6 lg:px-6">
          <button
            type="button"
            className="-m-2.5 p-2.5 lg:hidden"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <span className="sr-only">Toggle sidebar</span>
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          </button>
          <>
            <Header />
          </>
        </div>

        {/* <!-- Main content area --> */}
        <section className="flex-1 overflow-y-auto bg-body text-primary-fg">
          {children}
        </section>
      </div>
    </div>
  );
};

export default AuthLayout;
